export default {
    loading: "Cargando"
}